"use client";

import { AuthButton } from "@/components/auth-button";
import { useAuth } from "@/components/auth-provider";
import { PriceText } from "@/components/price-text";
import { useOfferCountdown } from "@/hooks/use-offer-countdown";
import { useStartingPrice } from "@/hooks/use-starting-price";
import { piEvents } from "@/lib/analytics";
import {
  PI_CTA_LOCATION,
  PI_CTA_NAME,
  PI_DESTINATION,
  PI_LOGIN_ENTRY_POINT,
} from "@/lib/analytics/schema";
import { DEFAULT_DISCOUNT_PERCENT, DEFAULT_ORIGINAL_PRICE } from "@/lib/site-copy";

/** Sticky bottom CTA bar shown on small screens. */
export function MobileStickyCta() {
  const startingPrice = useStartingPrice();
  const countdown = useOfferCountdown();
  const { isSignedIn } = useAuth();
  const discountPercent = startingPrice?.discountPercent ?? DEFAULT_DISCOUNT_PERCENT;

  return (
    <div className="fixed right-0 bottom-0 left-0 z-[60] flex flex-col border-t border-pi-border-muted shadow-[0_-12px_30px_rgba(0,0,0,0.5)] md:hidden">
      <div className="flex items-center justify-center gap-2 bg-gradient-to-r from-[#2a1d03] via-[#4a3406] to-[#2a1d03] px-4 py-1.5">
        <span className="size-1.5 shrink-0 animate-pulse rounded-full bg-[#FF5A3C]" />
        <span className="text-xs font-bold tracking-[0.04em] text-pi-gold">
          {discountPercent}% OFF khatam hone mein{" "}
          <PriceText
            value={countdown.clock}
            className="min-w-[6ch] tabular-nums"
          />
        </span>
      </div>
      <div className="flex items-center gap-3 bg-white px-4 py-2.5">
        <div className="min-w-0 leading-tight">
          <div className="text-xs text-[#6B6B76] line-through">
            {startingPrice?.originalPrice ?? DEFAULT_ORIGINAL_PRICE}
          </div>
          <div className="text-[19px] font-extrabold whitespace-nowrap text-[#111114]">
            <PriceText value={startingPrice?.amount} className="min-w-[4ch]" />
            <span className="text-xs font-normal text-[#6B6B76]">/mo</span>
          </div>
        </div>
        <AuthButton
          appearance="plain"
          loginEntryPoint={PI_LOGIN_ENTRY_POINT.STICKY_MOBILE_START_LEARNING}
          trackClick={() =>
            piEvents.ctaClicked({
              ctaName: PI_CTA_NAME.START_LEARNING_FREE,
              ctaLocation: PI_CTA_LOCATION.STICKY_MOBILE,
              destination: isSignedIn
                ? PI_DESTINATION.PW_HOME
                : PI_DESTINATION.LOGIN_MODAL,
            })
          }
          className="min-w-0 flex-1 cursor-pointer rounded-xl border-0 bg-pi-gold px-4 py-[13px] text-center text-[15px] font-bold break-words text-[#1a1200] no-underline"
        >
          Start Learning →
        </AuthButton>
      </div>
    </div>
  );
}
